const viewAll = () => {

  const receptionTable = document.querySelector('.project-results__table-wrapper');

  if (!receptionTable) {
    return;
  }

  const viewAllButton = document.querySelector('.project-results__button-wrapper');

  viewAllButton.addEventListener('click', function () {
    receptionTable.style.maxHeight = 'fit-content';
    viewAllButton.style.display = 'none';
  });

};

export {viewAll};
